import { RadioButtonV2, RadioButtonV2Props } from './RadioButton';

type RadioButtonV2Options = RadioButtonV2Props;

export type RadioGroupV2Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> & {
	name: string;
	value: string;
	options: RadioButtonV2Options[];
	groupLabel: string;
	dataTestId?: string;
	onValueChange: (value: string) => void;
	required?: boolean;
	disabled?: boolean;
	variant?: 'small' | 'large' | 'card';
};

export const RadioGroupV2 = ({
	name,
	value,
	options,
	groupLabel,
	dataTestId = '',
	onValueChange,
	required = false,
	disabled = false,
	variant = 'small',
	...rest
}: RadioGroupV2Props) => {
	return (
		<fieldset className='block'>
			<legend className={`block text-primaryTextDark mb-2 ${disabled ? 'opacity-25' : ''}`}>
				{groupLabel}
				{required && <span className='text-md text-error ml-1 leading-[14px]'>*</span>}
			</legend>
			<div
				role='radiogroup'
				data-test-id={dataTestId}
				className={`${variant === 'card' ? 'grid grid-cols-2 items-start gap-6' : 'pt-4'}`}
				{...rest}
			>
				{options.map((opt: RadioButtonV2Options, i: number) => (
					<RadioButtonV2
						key={i}
						label={opt.label}
						description={opt.description}
						name={name}
						value={opt.value}
						checked={opt.value === value}
						disabled={disabled || opt.disabled}
						onChange={(e) => {
							if (e.target.checked) onValueChange(opt.value);
						}}
						variant={variant}
					/>
				))}
			</div>
		</fieldset>
	);
};
